import React from 'react';
import { Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { compose } from 'recompose';
import { Global, ThemeProvider } from '@emotion/react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import routes from 'app/router/routes';
import globalStyles from 'app/styles/globalStyles';
import { theme } from 'app/styles/selectors/theme';
import ConnectedIntlProvider from 'app/features/localization/enhancers/ConnectedIntlProvider';
import Favicons from 'app/components/layout/Favicons';
import { onAppLoaded, onAppUnload } from 'app/actions';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import withDispatchOnUnmount from 'app/enhancers/withDispatchOnUnmount';
import ErrorBoundary from 'app/components/errorPages/ErrorBoundary';
import InternalErrorRedirect from 'app/router/InternalErrorRedirect';
import NotFoundPrerenderMeta from 'app/router/NotFoundPrerenderMeta';

const UI = ({ history, theme }) => (
  <ThemeProvider theme={theme}>
    <Favicons />
    <Global styles={globalStyles(theme.global)} />
    <ConnectedRouter history={history}>
      <ConnectedIntlProvider>
        <ErrorBoundary FallbackComponent={InternalErrorRedirect}>
          <NotFoundPrerenderMeta />
          <Switch>{routes}</Switch>
        </ErrorBoundary>
      </ConnectedIntlProvider>
    </ConnectedRouter>
  </ThemeProvider>
);

UI.propTypes = {
  history: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({
    global: PropTypes.shape({}),
  }).isRequired,
};

const App = compose(
  connect({ theme }),
  withDispatchOnMount(onAppLoaded),
  withDispatchOnUnmount(onAppUnload),
)(UI);

export default App;
